
const ENotificationChannels = 
{
  GlobalChannel: 0,
}


export default ENotificationChannels; 
